import Credentials from "../components/organisms/Credentials";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {

  const navigate = useNavigate();

  useEffect(() => {
    // Check if accessToken is present in localStorage
    const token = localStorage.getItem("accessToken");
    if (token) {
      // Redirect to /dashboard/testimonial if accessToken is found
      navigate("/dashboard/testimonial");
    }
  }, [navigate]);

  return (
    <div className="flex w-screen h-screen">
      <div className="w-[75%] overflow-hidden">
        <img className="w-full h-full" src="/images/login_img.jpg" alt="login-img" />
      </div>
      <div className="p-4 px-10 w-[25%] flex items-center justify-center">
        <Credentials/>
      </div>
    </div>
  );
}
